import { render, staticRenderFns } from "./ListWithAvatar.vue?vue&type=template&id=568876d0&"
import script from "./ListWithAvatar.vue?vue&type=script&lang=js&"
export * from "./ListWithAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports